import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const REMINDERS_SCHEMA = Object.freeze({
  ENABLED: false,
});
const RECORD = generateSchema(REMINDERS_SCHEMA);
const KEYS: any = generateKeys(REMINDERS_SCHEMA);

export class Reminders extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get enabled(): boolean {
    return this.get(KEYS.ENABLED);
  }
}
